import React from 'react';
import { ArrowDownOutlined, ArrowUpOutlined, ShopOutlined, RiseOutlined  } from '@ant-design/icons';
import { Card, Col, Row, Statistic } from 'antd';


const HomePage = () => {
  return (
    <div>
      <h5>Home Page</h5>
      <Row gutter={16}>

        <Col span={12}>
          <Card bordered={false}>
            <Statistic
              title="Total"
              value={128}
              precision={0}
              valueStyle={{
                color: '#3f8600',
              }}
              prefix={<null />}
              suffix=""
            />
          </Card>
        </Col>
        <Col span={12}>
          <Card bordered={false}>
            <Statistic
              title="New Active"
              value={28}
              precision={0}
              valueStyle={{
                color: '#3f8600',
              }}
              prefix={<ArrowUpOutlined />}
              suffix=""
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default HomePage;
